const checkApi = (state = {}, action) => {
  switch (action.type) {
    case "ERROR":
      state = action.payload;
      return state;
    default:
      return state;
  }
};
export default checkApi;
